<script setup lang="ts">
import { QA_TABLES } from '@modules/tables/constants';

import type { ITableOrderEmits, ITableOrderProps } from './types';

const props = defineProps<ITableOrderProps>();
const emit = defineEmits<ITableOrderEmits>();

function handleOrder(columnName: string): void {
  if (props.disabled)
    return;
  emit('order-update', columnName);
}
</script>

<template>
  <span v-data-qa-auto-id="'VTableOrder'"
    v-if="column.sort"
    v-data-test="{ el: QA_TABLES.headCellSort, columnName: column.name }"
    class="p-datatable-sort-icon cursor-pointer"
    :class="{ 'p-disabled': disabled }"
    @click="handleOrder(column.name)"
  >
    <i
      :class="{
        'pi-sort-alt': !tableState?.order?.[column.name],
        'pi-sort-amount-down': tableState?.order?.[column.name] === 'desc',
        'pi-sort-amount-up': tableState?.order?.[column.name] === 'asc',
        'text-primary': !!tableState?.order?.[column.name],
      }"
      class="pi"
    />
  </span>
</template>
